var map = {
	"./symbol_0.png": 64764,
	"./symbol_1.png": 677,
	"./symbol_10.png": 32353,
	"./symbol_11_free.png": 64307,
	"./symbol_11_normal.png": 6560,
	"./symbol_12_free.png": 33842,
	"./symbol_12_normal.png": 25365,
	"./symbol_13_free.png": 18109,
	"./symbol_13_normal.png": 45406,
	"./symbol_14_free.png": 28084,
	"./symbol_14_normal.png": 17147,
	"./symbol_15_free.png": 83471,
	"./symbol_15_normal.png": 1812,
	"./symbol_16_free.png": 7454,
	"./symbol_16_normal.png": 7833,
	"./symbol_17_free.png": 85593,
	"./symbol_17_normal.png": 4437,
	"./symbol_18_free.png": 21440,
	"./symbol_18_normal.png": 17871,
	"./symbol_19_free.png": 11787,
	"./symbol_19_normal.png": 9240,
	"./symbol_2.png": 72846,
	"./symbol_3.png": 72343,
	"./symbol_4.png": 50200,
	"./symbol_5.png": 87681,
	"./symbol_6.png": 30250,
	"./symbol_7.png": 62163,
	"./symbol_8.png": 19892,
	"./symbol_9.png": 41021
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84183;